import api from "../../index";

export const AddUpdateLeadApi = (data) => api.post('salesdashboard/add-update-sales-lead', data);
export const GetAllSourceApi = () => api.get('salesdashboard/getall-sales-source');
export const GetAllLeadsApi = (params) => api.get(`salesdashboard/get-all-sales-lead?${params}`);
export const UpdateLeadStatusApi = (data) => api.patch('salesdashboard/update-sales-lead-status', data);
export const ImportLeadsApi = (data, header) => api.post('salesdashboard/upload-saleslead', data, header);
